"use client";

import { useEffect, useState } from "react";

/** Defers non-critical shell widgets (credits, bell) to avoid competing with first paint. */
export function useDeferredShellUi(delayMs = 700): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timeout = window.setTimeout(() => setReady(true), delayMs);
    return () => window.clearTimeout(timeout);
  }, [delayMs]);

  return ready;
}
